import React from 'react';
import Head from 'next/head';
import { SEGMENT_PATHS, SEGMENTS } from '@sparknz/journeys-common';

import { BASE_PATH, DOMAIN } from 'shared/constants';
import { Segment } from 'shared/hooks';
import { getMetaDataTitle } from 'shared/utils/metaData.utils';

export interface MetaTagsProps {
  slug?: string | string[];
  title: string;
  description: string;
  segment: Segment;
  canonicalUrl: string;
  image?: string;
}

const generateCanonicalLink = (segment: Segment, canonicalUrl: string) => {
  switch (segment) {
    case SEGMENTS.LARGE_BUSINESS:
      return `${DOMAIN}${BASE_PATH}${SEGMENT_PATHS.LARGE_BUSINESS_AND_GOVERNMENT}/${canonicalUrl}`;
    case SEGMENTS.BUSINESS:
      return `${DOMAIN}${BASE_PATH}${SEGMENT_PATHS.BUSINESS}/${canonicalUrl}`;
    default:
      return `${DOMAIN}${BASE_PATH}/${canonicalUrl}`;
  }
};

const MetaTags = ({
  description,
  title,
  segment,
  canonicalUrl,
  image,
}: MetaTagsProps) => {
  return (
    <Head>
      <title>{getMetaDataTitle(title, segment)}</title>

      <meta
        className="elastic"
        data-type="string"
        name="title"
        content={title}
      />

      <meta
        className="elastic"
        data-type="text"
        name="description"
        content={description}
      />

      <meta
        className="elastic"
        data-type="string"
        name="pagetype"
        content={segment}
      />
      <meta
        className="elastic"
        data-type="string"
        name="pagetype"
        content="shop"
      />

      <meta
        className="elastic"
        name="consumerrelevance"
        data-type="integer"
        content={segment === SEGMENTS.PERSONAL ? '10' : '0'}
      />

      <meta
        className="elastic"
        name="businessrelevance"
        data-type="integer"
        content={segment === SEGMENTS.BUSINESS ? '10' : '0'}
      />

      <meta
        className="elastic"
        name="largebusinessrelevance"
        data-type="integer"
        content={segment === SEGMENTS.LARGE_BUSINESS ? '10' : '0'}
      />

      <link
        rel="canonical"
        href={generateCanonicalLink(segment, canonicalUrl)}
      />

      {image ? <meta property="og:image" content={image} /> : null}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="robots" content="index,follow" />
    </Head>
  );
};

export default MetaTags;
